module.exports = __webpack_public_path__ + "img/rank-icon.bd56e633.png";